import { changePasswordHeaderStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePasswordHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

changePasswordHeaderStyles.title = {
    variant: "h2",
    as: "h1",
    css: css`
        color: ${getColor("primary")};
        margin-bottom: 7px;
    `,
};
